import { registerPlugin } from "@capacitor/core";

import type { MultiplayerBlePlugin } from "./definitions.js";

/// Capacitor plugin registration. The web bundle dynamically imports
/// the `web.ts` fallback if no native implementation is registered
/// — see `registerPlugin` docs.
export const MultiplayerBle = registerPlugin<MultiplayerBlePlugin>(
  "MultiplayerBle",
  {
    web: () => import("./web.js").then((m) => new m.MultiplayerBleWeb()),
  },
);

export type {
  ClosedEvent,
  ErrorEvent,
  FrameEvent,
  InitializeOptions,
  MultiplayerBlePlugin,
  OpenedEvent,
  PermissionStatus,
  Role,
  SendOptions,
} from "./definitions.js";

export { BleTransport } from "./bleTransport.js";
export {
  BROADCAST_SERVICE_UUID,
  BROADCAST_CHAR_UUID,
  Broadcaster,
  Listener,
} from "./broadcast.js";
